import api from "./api";


export const createAssessment = async (payload) => {

    try {

        const response = await api.post(
            "/agent-certification-assessment/admin/assessments",
            payload
        );

        if (
            response.status === 200 ||
            response.status === 201
        ) {

            if (response.data?.success) {

                return {
                    success: true,
                    data: response.data.data,
                };

            }

        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Unexpected response from server",
        };

    } catch (error) {

        console.error(
            "Error creating assessment:",
            error.message || error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to create assessment",
        };

    }
};



export const fetchAssessments = async () => {

    try {

        const response = await api.get(
            "/agent-certification-assessment/admin/assessments"
        );

        if (
            response.status === 200 &&
            response.data?.success
        ) {

            return {
                success: true,
                data: response.data.data || [],
            };

        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Unexpected response from server",
        };

    } catch (error) {

        console.error(
            "Error fetching assessments:",
            error.message || error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch assessments",
        };

    }
};


export const updateAssessment = async (
    assessmentId,
    payload
) => {

    try {

        const response = await api.put(
            `/agent-certification-assessment/admin/assessments/${assessmentId}`,
            payload
        );

        if (
            response.status === 200 &&
            response.data?.success
        ) {

            return {
                success: true,
                data: response.data.data,
            };

        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Unexpected response from server",
        };

    } catch (error) {

        console.error(
            "Error updating assessment:",
            error.message || error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to update assessment",
        };

    }
};



export const deleteAssessment = async (
    assessmentId
) => {

    try {

        const response = await api.delete(
            `/agent-certification-assessment/admin/assessments/${assessmentId}`
        );

        if (
            response.status === 200 &&
            response.data?.success
        ) {

            return {
                success: true,
                data: response.data.data,
                message:
                    response.data.message ||
                    "Assessment deleted successfully",
            };

        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Unexpected response from server",
        };

    } catch (error) {

        console.error(
            "Error deleting assessment:",
            error.message || error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to delete assessment",
        };

    }
};